import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'ez-fee-info-box',
  imports: [CurrencyPipe],
  templateUrl: './fee-info-box.component.html',
  styleUrl: './fee-info-box.component.scss',
})
export class FeeInfoBoxComponent {
  @Input() amountInEuro: number;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() customerNumber: string;
}
